import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Table } from 'antd';
import dayjs from 'dayjs';

import React, { useContext, useEffect, useRef, useState } from 'react'
import systemConfig from '../../../../config/systematic';
import fetchApi from '../../../../utils/api/fetchApi';
import getList from '../../../universal/getList';
import antMessage from '../../../../utils/extend/AntdNotification'
import entrepotPrint from '../../../../generalMethod/entrepotPrint';
import 'dayjs/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { showCustomNotification, useNotificationInstance } from '../../../../utils/extend/AntdNotificationEx';
import { SocketContext } from '../../../../App';
import moment from 'moment';

const { RangePicker } = DatePicker;
export default function EntrepotDailyReport() {
  const contentRef = useRef<any>(null);
  /** 后端数据wmService */
  let wmService: any = systemConfig.wmService;
  const [form] = Form.useForm()
  const [deptData, setDeptData] = useState<any>();

  const [orderTypeData, setOrderTypeData] = useState<any>()
  const [buyerData, setBuyerData] = useState<any>()

  const [queryCriteria, setQueryCriteria] = useState<any>("")
  const [user, setUser] = useState<any>("")
  const notificationApi = useNotificationInstance()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const useContextData = useContext(SocketContext);
  const { contextData } = useContextData;
  const [buyerName, setBuyerName] = useState<string>("所有采购");
  const [deptName, setDeptName] = useState<string>("所有部门");
  // const [classificationWarehouseName, setClassificationWarehouseName] = useState<string>("所有分类");
  // const [classificationWarehouseData, setClassificationWarehouseData] = useState<any>();
  const [warehouseCategoriesData, setWarehouseCategoriesData] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [warehouseCategoriesName, setWarehouseCategoriesName] = useState<any>("所有大类")
  const initialValues: any = {
    chooseTime: [dayjs(), dayjs()],
    isBuyerDetail: true,
    orderStatus: 2,
    dataStatusType:1
  };
 
  const [dataTypeData, setDataTypeData] = useState<Array<any>>();
  const columnsHead: Array<any> = [
    {
      title: '来源',
      dataIndex: 'productSources',
      align: "center"
    },
    {
      title: '收货',
      children: [
        {
          title: '金额',
          dataIndex: 'purchaseAmount',
          render: (text: any) => (text ? text.toFixed(2) : "0.00"),
          align: "center"
        },
        {
          title: '张数',
          dataIndex: 'purchaseCount',
          render: (text: any) => (text ? text : 0),
          align: "center"
        }
      ]
    },
    {
      title: '调出',
      children: [
        {
          title: '金额',
          dataIndex: 'importAmount',
          render: (text: any) => (text ? text.toFixed(2) : "0.00"),
          align: "center"
        },
        {
          title: '张数',
          dataIndex: 'importCount',
          render: (text: any) => (text ? text : 0),
          align: "center"
        }
      ]

    },
    {
      title: '调入',
      children: [
        {
          title: '金额',
          dataIndex: 'exportAmount',
          render: (text: any) => (text ? text.toFixed(2) : "0.00"),
          align: "center"
        },
        {
          title: '张数',
          dataIndex: 'exportCount',
          render: (text: any) => (text ? text : 0),
          align: "center"

        }
      ]
    },
    // {
    //   title: '张数(调入)',
    //   dataIndex: 'exportCount',
    //   render: (text: any) => (text ? text: 0)

    // },
    // {
    //   title: '损溢',
    //   dataIndex: 'changed',
    // },

  ];
  useEffect(() => {

    const fetchData = async () => {
      form.setFieldValue("chooseTime", [dayjs(), dayjs()])
      fetchApi.GET(wmService,
        {
          apiId: 'generalData',
          apiVariable: 'dataStatusType',
          apiExtend: 'showLists'
        }
      ).then(res => {
        if (res.success) {
          const { dataStatusType } = res.data


          setDataTypeData(dataStatusType)
        }
      })
      let deptData = await fetchApi.GET(wmService, {
        apiId: "dept",
        apiExtend: 'showList',
        apiData: {

        }
      })

      if (deptData.success) {
        setDeptData(deptData.data)
      }
      let orderTypeData = await fetchApi.GET(wmService, {
        apiId: "entrepot",
        apiExtend: 'getOrderType'
      })


      if (orderTypeData.success) {
        setOrderTypeData(orderTypeData.data)
      }
      let buyerData = await fetchApi.GET(wmService, {
        apiId: "buyer",
        apiExtend: 'showList'
      })

      if (buyerData.success) {

        setBuyerData(buyerData.data)
      }

      // let classificationWarehouseData = await fetchApi.GET(wmService, {
      //   apiId: "classificationWarehouse",
      //   apiExtend: 'showList'
      // })

      // if (classificationWarehouseData.success) {
      //   setClassificationWarehouseData(classificationWarehouseData.data)
      // }

      let warehouseCategoriesData = await fetchApi.GET(wmService, {
        apiId: "warehouseCategories",
        apiExtend: 'showList'
      })

     
      if (warehouseCategoriesData.success) {

        setWarehouseCategoriesData(warehouseCategoriesData.data)
      }

    }
    fetchData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  const onFinish = () => {
    setIsLoading(true)
    form.validateFields()
      .then(async (values: any) => {


        fetchApi.GET(wmService, {
          apiId: "entrepotReport",
          apiExtend: 'dailyReportEx',
          apiData: {
            ...values,
            deptIds: values.deptIds,
            orderTypes: values.orderTypes,
            isBuyerDetail: values.isBuyerDetail ? values.isBuyerDetail : false,
            time: values.chooseTime ? {
              startTime: dayjs(values.chooseTime[0]).format("YYYY-MM-DD"),
              endTime: dayjs(values.chooseTime[1]).format("YYYY-MM-DD"),
            } : null,
            buyers: values.buyers,
            selfs: values.selfStart && values.selfEnd ? {
              selfStart: values.selfStart,
              selfEnd: values.selfEnd
            } : null,
            isCurrentBranchStore: values.isCurrentBranchStore,
            isBigOrder: values.isBigOrder,
            entrepotId: contextData?.currentEntrepotId,
            mountDataOptions: {
              userMount: {
                isEmployees: true,
                isDept: true,
                isUserAreas: true
              }
            },
          }
        }).then((res: any) => {

          setRows(res.data.rows)
          setQueryCriteria(res.data.queryCriteria)
          setUser(res.data.user)
          showCustomNotification(notificationApi!, {
            type: 'success',
            message: "搜索成功",
            description: "success"
          });;
          setIsLoading(false)

        }).catch((err: any) => {
          console.log("err", err);
          setIsLoading(false)

          antMessage('error', '搜索失败', err.message + ' | status：' + err.errors.status);
        })
      })
      .catch((err) => {
        setIsLoading(false)

        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });;
      })
  }

  const onChangeBranchStore = (e: any) => {
    let checked = e.target.checked;

    if (checked) {
      fetchApi.GET(wmService, {
        apiId: "branchStore",
        apiExtend: 'getDeptByentrepot',
        apiData: {
          entrepotId: contextData?.currentEntrepotId
        }

      }).then((res: any) => {

        if (res.success) {
          let detpName = [];
          let deptId = [];
          if (res.data.length > 0) {
            setDeptData(res.data)
            for (let i = 0; i < res.data.length; i++) {
              detpName.push(res.data[i].deptName);
              deptId.push(res.data[i].id);

            }
            form.setFieldValue("deptIds", deptId)
            setDeptName(detpName.join("|"))

          }


        } else {
          form.setFieldValue("deptIds", [])
        }


      }).catch((err: any) => {
        form.setFieldValue("deptIds", [])
        console.log("err", err);


      })
    } else {
      form.setFieldValue("deptIds", [])
    }

  }
  const changeDept = (e: any, option: any) => {
    let deptName: Array<any> = [];
    for (let i = 0; i < option?.length; i++) {
      deptName.push(option[i].children)
    }
    setDeptName(deptName.join("|"))
  }
  const onChangeWarehouseCategories = (e: any, option: any) => {
    let warehouseCategoriesName: Array<any> = [];
    for (let i = 0; i < option?.length; i++) {
      warehouseCategoriesName.push(option[i].children)
    }
    setWarehouseCategoriesName(warehouseCategoriesName.join("|"))
  }
  const changeBuyers = (e: any, option: any) => {
    let buyerName: Array<any> = [];
    for (let i = 0; i < option?.length; i++) {
      buyerName.push(option[i].children)
    }
    setBuyerName(buyerName.join("|"))
  }
  const handlePrint = () => {
    if (rows.length === 0) {
      antMessage('error', '打印失败', "无打印数据");
      return false
    }
    let table = document.getElementsByTagName("table")[0]
    table.border = "1";
    table.style.width = "100%";
    table.cellPadding = "0";
    table.cellSpacing = "0";
    let data = document.getElementById("aa")?.innerHTML;

    entrepotPrint.printEnReportEx(JSON.stringify(data), "exDailyReport")
  }
  const footer = (data: any) => {
    return <div style={{ display: "flex", justifyContent: 'space-between' }}>
      <div>制表人:{user?.userName}</div>
      <div>打印日期:{moment().format("YYYY-MM-DD HH:mm:ss")}</div>

    </div>
  }
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={initialValues}
      >
        <Row>
          <Col span={16}>
            <Form.Item
              label="部门"
              name="deptIds"
            //  rules={[{ required: true, message: '请输入部门!' }]}
            >
              <Select
                // orderTypeData
                mode="multiple"
                showSearch
                placeholder="请选择部门!"
                optionFilterProp="children"
                onChange={changeDept}
                onSearch={(e) => getList.search('dept', setDeptData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(deptData, 'deptName')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label="订单类型"
              name="orderTypes"
            >
              <Select
                mode="multiple"
                showSearch
                placeholder="订单类型"
                optionFilterProp="children"
                // onSearch={(e) => getList.search('dept', setDeptData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(orderTypeData, 'orderTypeName', "orderType")}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="采购商"
              name="buyers"
            >
              <Select
                onChange={changeBuyers}
                mode="multiple"
                showSearch
                placeholder="采购商"
                optionFilterProp="children"
                onSearch={(e) => getList.search('buyer', setBuyerData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(buyerData, 'buyerName')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={1.5}>
            <Form.Item
              label="采购商明细"
              name="isBuyerDetail"
              valuePropName="checked"
            >
              <Checkbox></Checkbox>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              label="品号"
              name="selfStart"
            >
              <Input
              // onChange={handleChange}
              // onBlur={handleBlur}
              // placeholder="Input a number"
              />
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              colon={false}
              label="-"
              name="selfEnd"
            >
              <Input
              // onChange={handleChange}
              // onBlur={handleBlur}
              // placeholder="Input a number"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="大类"
              name="warehouseCategoriesIds"
            >
              <Select
                onChange={onChangeWarehouseCategories}
                mode="multiple"
                showSearch
                placeholder="大类"
                optionFilterProp="children"
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(warehouseCategoriesData, 'warehouseCategoriesName')}
              </Select>
            </Form.Item>
          </Col>
          {/* <Col span={6}>
            <Form.Item
              label="品类"
              name="classificationWarehouses"
            >
              <Select
                mode="multiple"
                showSearch
                placeholder="品类"
                optionFilterProp="children"
                onSearch={(e) => getList.search('classificationWarehouse', setClassificationWarehouseData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(classificationWarehouseData, 'classificationWarehouseName')}
              </Select>
            </Form.Item>
          </Col> */}
          <Col span={6}>
            <Form.Item
              label="日期"
              name="chooseTime"

            >
              <RangePicker
                locale={locale}
                defaultValue={initialValues.chooseTime}
                format="YYYY-MM-DD"
              />
            </Form.Item>
          </Col>

          <Col span={1.5}>
            <Form.Item
              label="当前分店"
              name="isCurrentBranchStore"
              valuePropName="checked"

            >
              <Checkbox onChange={onChangeBranchStore}></Checkbox>
            </Form.Item>
          </Col>

          {/* <Col span={6}>
            <Form.Item
              label="单状态"
              name="orderStatus"
            >
              <Select
                showSearch
                placeholder="单状态"
                optionFilterProp="children"
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(orderStatus)}
              </Select>
            </Form.Item>
          </Col> */}
          <Col span={1.5}>
            <Form.Item
              label="大单"
              name="isBigOrder"
              valuePropName="checked"

            >
              <Checkbox ></Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="dataStatusType"
            >
              <Select
                defaultValue="数据状态"
                placeholder="数据状态"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(dataTypeData)}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item >
              <Space>
                <Button loading={isLoading} htmlType="submit">
                  统计
                </Button >
                {/* <Button onClick={() => entrepotPrint.printEnReport(rows, "entrepotDailyReportPrint", { ...queryCriteria, deptName, buyerName }, user)} >
                  打印
                </Button> */}
                <Button onClick={handlePrint} >
                  打印
                </Button>

              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>



      {/* <Button onClick={() => DownloadExcel(rows, "moonReport",queryCriteria)}>下载EXCEL文件</Button> */}
      <div id='aa' ref={contentRef}>
        {/* <div style={{ marginTop: "20px" }}> */}
        <div style={{ fontSize: 20, textAlign: "center", marginBottom: 10 }}>日报表</div>
        <div style={{ fontSize: 16, textAlign: "center", marginBottom: 10, display: "flex", justifyContent: "space-between", }}>
          <div>部门：{deptName}</div>
          <div>采购商：{buyerName}</div>

        </div>

        <div style={{ fontSize: 14, textAlign: "center", marginBottom: 10, display: "flex", justifyContent: "space-between", }}>
          <div>大类:{warehouseCategoriesName}</div>

          <div>品号:{queryCriteria.selfs}</div>
          <div>日期:{queryCriteria.date}</div>

        </div>
        <Table
          footer={footer}
          pagination={false}
          rowKey={(record: any) => record.id}
          columns={columnsHead}
          dataSource={rows}

        >
        </Table>
      </div>
    </>
  )
}
export let handleData = (rows: any, objKey: string) => {
  let newArr: Array<any> = []

  if (typeof rows === "undefined") return newArr

  for (var i = 0; i < rows.length; i++) {
    newArr.push({
      [objKey]: rows[i]
    })
  }

  return newArr
}